import React from "react";
import { useContent } from "../context/ContentContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

const ORANGE = "#ff6a2b";
const GREEN = "#2ec9a8";
const YELLOW = "#d4b23c";

const BANNER_IMG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/v3bah7r6_KILOMBO-NOSOTROS.png";

const TEAM = [
  {
    name: "César Escola",
    role: "Dirección musical",
    color: YELLOW,
    photo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/x141c9yo_CESAR.webp",
    subtitle: "El talento que hace posible que la música cuente historias.",
    bio:
      "Músico, compositor y director musical colombo-argentino. Su carrera es la banda sonora de buena parte de la televisión que Colombia recuerda: dirigió la música de Yo soy Betty, la fea y ha sido director artístico y musical de La Voz Kids, Yo Me Llamo y A Otro Nivel. Como productor ha trabajado con Maluma, Sebastián Yatra, Andrés Cepeda y Fanny Lu, y ha llevado su música al teatro musical —Chicago, Cabaret, La Jaula de las Locas—. En Kilombo pone ese oído al servicio de cada proyecto: que no solo suene bien, sino que se quede.",
    extra: "Reconocimientos: Grammy Latino, India Catalina, TV y Novelas, Premio Nacional de Cinematografía Focine. También conceptualiza eventos de marca (Premio Titanes Caracol) y facilita experiencias de equipo → Kilombo Teams.",
    trayectoria: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/9d2r66bs_cesar%20escola%20trayectoria.png",
  },
  {
    name: "Jairo Vargas",
    role: "Kilombo Music",
    color: ORANGE,
    photo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/5ec6q612_JAIRO.webp",
    subtitle: "Diseñar identidad sonora de una marca no es arte, es rigor y experiencia.",
    bio:
      "Compositor, productor discográfico y baterista, con 22 años en el entretenimiento y una obsesión: el sonido como activo de marca, no como jingle. Ha producido canciones para Andrés Cepeda, Maía, Majida Issa y Q'arto aparte, compuesto bandas sonoras para cine con directores como Felipe Martínez Amador, Sergio Cabrera y Carlos Moreno, y firmado más de 900 piezas para marcas como Pepsi, Mobil, Avianca y Jeep. Su especialidad —donde marketing y música se cruzan— es traducir el ADN de una marca en algo que las personas reconocen sin ver el logo.",
    extra: "Cine: Malcriados, Amazonas, Fortuna Lake, Doble. Discográfica y publicidad para +30 marcas. Y 12 años facilitando procesos de equipos de alto desempeño → Kilombo Teams.",
    trayectoria: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/kth8sqil_jairo%20vargas%20trayectoria.png",
  },
  {
    name: "Alejandro Morales",
    role: "Kilombo Teams",
    color: GREEN,
    photo: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/ovddmlsx_Alejandro.webp",
    subtitle: "Traductor de necesidades y objetivos en actitudes y comportamientos.",
    bio:
      "Comunicador social especializado en comunicación organizacional y storytelling; 13 años como director creativo en Sancho BBDO antes de liderar la creación de contenidos en Kilombo. Coach certificado en PNL, Story telling y narrativas personales, ha trabajado campañas para más de 300 marcas como Grupo Aval, Davivienda, Chevrolet, Mars y la Presidencia de la República. Y lleva 20 años diseñando, junto a los clientes, experiencias que fortalecen equipos de alto desempeño. Une dos mundos que casi nunca se tocan: el rigor de la comunicación de marca y el arte del escenario.",
    extra: "Autor, productor y actor de teatro musical; parte de la compañía infantil María del Sol y Cantaclaro (6 álbumes). Clientes de equipo: Abbott, Terpel, GSK, Mobil, Solística, Dell → Kilombo Teams.",
    trayectoria: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/n99y18f2_alejandro%20morales%20trayectoria.png",
  },
];

const CLIENT_LOGOS = [
  { name: "Alpina", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/v8njw3xg_Kis%20-%20Alpina.jpg" },
  { name: "Baloto", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/2zbrlw92_Kis%20-%20Baloto.jpg" },
  { name: "Bisbacter", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/npnoqipy_Kis%20-%20Bisbacter.jpg" },
  { name: "Blu Radio", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/kaq56dck_Kis%20-%20Blu.jpg" },
  { name: "Caracol Televisión", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/wa5g2n0e_Kis%20-%20CARACOL.jpg" },
  { name: "Casa Luker", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/ugpqdhkm_Kis%20-%20Casa%20Luker.jpg" },
  { name: "Cámara de Comercio de Bogotá", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/jcy74r1c_Kis%20-%20CCB.jpg" },
  { name: "Chevrolet", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/xmwc872f_Kis%20-%20Chevrolet.jpg" },
  { name: "Compañía Nacional de Chocolates", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/uaiodgq0_Kis%20-%20CNChocolates.jpg" },
  { name: "Compensar", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/so4wwau7_Kis%20-%20Compensar.jpg" },
  { name: "Crem Helado", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/ubd5bkg3_Kis%20-%20Crem%20Helado.jpg" },
  { name: "Cruz Verde", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/f7u4u53p_Kis%20-%20Cruz%20Verde.jpg" },
  { name: "Dell", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/q0bmvcq3_Kis%20-%20DELL.jpg" },
  { name: "El Rey", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/v0yb3rtd_Kis%20-%20El%20Rey.jpg" },
  { name: "Genfar", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/hq735vma_Kis%20-%20Genfar.jpg" },
  { name: "GSK", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/j7ukt4ye_Kis%20-%20GSK.jpg" },
  { name: "Huawei", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/weasbkjn_Kis%20-%20Huawei.jpg" },
  { name: "ING", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/rj5nfss3_Kis%20-%20ING.jpg" },
  { name: "La Voz Kids", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/agrguaeg_Kis%20-%20La%20Voz%20Kids.jpg" },
  { name: "Los Informantes", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/w1fndm72_Kis%20-%20Los%20Informantes.jpg" },
  { name: "Luker Tradicional", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/y02omq75_Kis%20-%20Luker.jpg" },
  { name: "Luki Chocolate", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/uymibgnu_Kis%20-%20Luki.jpg" },
  { name: "McDonald's", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/l6y3e7il_Kis%20-%20McDonald%C2%B4s.jpg" },
  { name: "Nokia", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/29ey0f18_Kis%20-%20Nokia.jpg" },
  { name: "O Boticário", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/52vv7xs0_Kis%20-%20O%20Boticario.jpg" },
  { name: "Parmalat", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/vomtakm8_Kis%20-%20Parmalat.jpg" },
  { name: "PAX", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/u177d4zj_Kis%20-%20Pax.jpg" },
  { name: "Pepsi", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/sdys98c9_Kis%20-%20Pepsi.jpg" },
  { name: "Proyectil", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/vls11gvh_Kis%20-%20Proyectil.jpg" },
  { name: "Tampico", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/2bn30xi5_Kis%20-%20Tampico.jpg" },
  { name: "Team Foods", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/vqk0uwkl_Kis%20-%20TEAM.jpg" },
  { name: "TropiKola", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/idzqtyom_Kis%20-%20Tropikola.jpg" },
  { name: "Volvo", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/4342ph9u_Kis%20-%20VOLVO.jpg" },
  { name: "Winny", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/ltym9xk3_Kis%20-%20Winny.jpg" },
  { name: "Emulsión de Scott", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/afrob4wa_Kis_-_Emulsi%C3%B3n_Scott.jpg" },
  { name: "Sábados Felices", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/2i6qago8_Kis_-_S%C3%A1bados_Felices.jpg" },
  { name: "Salitre Mágico", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/p1z8wwjg_Kis_-_Salitre_M%C3%A1gico.jpg" },
  { name: "Sávital", image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_team-workspace-60/artifacts/8dz81k0b_Kis_-_S%C3%A1vital.jpg" },
];

export default function NosotrosPage() {
  const { content, loading } = useContent();
  if (loading || !content) {
    return <div className="min-h-screen bg-black flex items-center justify-center text-white/60 font-mono-caps tracking-widest">CARGANDO...</div>;
  }
  return (
    <div className="relative min-h-screen bg-black text-white overflow-x-hidden">
      <Header />

      {/* HERO — Banner collage (aspect 16:9) */}
      <section className="relative w-full aspect-[16/9] pt-28 md:pt-32 px-6 overflow-hidden">
        <img
          src={BANNER_IMG}
          alt="Kilombo — Nosotros"
          className="absolute inset-0 w-full h-full"
          style={{ objectFit: "cover", objectPosition: "center" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/10 to-black/95" />
        <div className="absolute inset-0 noise-overlay pointer-events-none" />

        <div className="absolute inset-x-0 bottom-0 z-10 px-6 pb-8 md:pb-14">
          <div className="max-w-6xl mx-auto w-full">
            <p className="font-mono-caps text-xs md:text-sm tracking-[0.3em] uppercase text-white/70">— Nosotros —</p>
            <h1 className="mt-4 font-display font-black tracking-tight text-[26px] leading-[1.05] sm:text-4xl md:text-5xl lg:text-6xl xl:text-[68px] max-w-5xl uppercase">
              Tres talentos.{" "}
              <span className="bg-gradient-to-r from-[#ff8a3c] to-[#ffb46b] bg-clip-text text-transparent">Dos universos.</span>{" "}
              Un propósito:{" "}
              <span className="bg-gradient-to-r from-[#5be0c3] to-[#2ec9a8] bg-clip-text text-transparent">detonar emociones</span>.
            </h1>
          </div>
        </div>
      </section>

      {/* INTRO — Kilombo */}
      <section className="relative bg-black py-20 md:py-28 px-6 border-t border-white/5">
        <div className="max-w-5xl mx-auto">
          <p className="font-mono-caps text-xs tracking-[0.3em] uppercase text-white/40 mb-4">— Kilombo —</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl leading-[1.05]">
            Un estudio de contenidos con una <span className="text-gradient-music">sola obsesión</span>: que marcas, artistas y equipos se reconozcan.
          </h2>
          <div className="mt-8 space-y-5 text-white/75 text-base md:text-lg leading-relaxed max-w-4xl">
            <p>
              Desde hace más de <span className="text-white font-semibold">25 años</span> cruzamos música, comunicación y creatividad en dos universos que parecen opuestos —el sonido de las marcas y la cultura de los equipos—. En ambos nos mueve lo mismo: el trabajo no termina cuando alguien escucha o participa, sino cuando detonamos las emociones correctas para que se reconozcan de manera más efectiva en lo que hacen.
            </p>
            <p>
              <span className="text-white font-semibold">Alejandro Morales, Jairo Vargas y César Escola</span> forman el corazón de este laboratorio de experiencias y sonidos. Tres oficios distintos, una misma forma de escuchar: cada uno aporta desde su especialidad para que el resultado no solo suene bien o se viva bien, sino que movilice hacia los objetivos.
            </p>
          </div>
        </div>
      </section>

      {/* KILOMBO MUSIC block */}
      <section className="relative bg-neutral-950 py-20 md:py-28 px-6 border-t border-white/5">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-3 h-3 rounded-full" style={{ background: ORANGE }} />
            <h3 className="font-heading text-2xl md:text-3xl tracking-[0.06em] uppercase" style={{ color: ORANGE }}>Kilombo Music</h3>
          </div>
          <h4 className="font-display font-bold text-2xl md:text-3xl lg:text-4xl text-white leading-tight max-w-4xl">
            Guardianes de la <span className="text-gradient-music">identidad sonora</span> — de marcas, historias y artistas.
          </h4>
          <div className="mt-8 space-y-5 text-white/75 text-base md:text-lg leading-relaxed max-w-4xl">
            <p>
              Diseñamos y producimos música en tres frentes: la identidad sonora de las marcas, música original para tv, series y cine, y la conceptualización y producción discográfica de artistas.
            </p>
            <p>
              Durante más de 25 años hemos acompañado a las organizaciones a que definan cómo suena su marca. Construyendo, desarrollando y adaptando al oído local o regional, la identidad sonora de marcas como <span className="text-white">Pepsi, GSK, Bayer, Postobón, Almacenes Éxito, Servientrega, Avianca, Chevrolet, Baloto, Blu Radio, Central Cervecera, Grupo Aval, Johnson &amp; Johnson, HSBC, Dell, Crem Helado, Parmalat, Genfar, El Tiempo, Honda, El Corral, Luker, Telemedellín y Alpina</span>.
            </p>
            <p>
              Y llevamos esa misma sensibilidad a la industria del entretenimiento: hemos producido y compuesto para artistas como <span className="text-white">Andrés Cepeda, Maía, Cuarto Aparte, Emilio José, Maluma, Fanny Lu y Marbelle, Marcelo Cezan</span> y puesto nuestra música al servicio de productoras como <span className="text-white">Caracol, Sony Music, RCN, FOX, Dynamo y TV Azteca</span>.
            </p>
            <p className="text-white font-medium italic">
              "Cuando un cliente escucha el resultado y dice 'esa es mi marca y esa es la emoción que necesitamos despertar', sabemos que el sonido dejó de ser música y se volvió identidad."
            </p>
          </div>
        </div>
      </section>

      {/* KILOMBO TEAMS block */}
      <section className="relative bg-black py-20 md:py-28 px-6 border-t border-white/5">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-3 h-3 rounded-full" style={{ background: GREEN }} />
            <h3 className="font-heading text-2xl md:text-3xl tracking-[0.06em] uppercase" style={{ color: GREEN }}>Kilombo Teams</h3>
          </div>
          <h4 className="font-display font-bold text-2xl md:text-3xl lg:text-4xl text-white leading-tight max-w-4xl">
            Incitadores de <span className="text-gradient-teams">movimiento</span> en la cultura organizacional.
          </h4>
          <div className="mt-8 space-y-5 text-white/75 text-base md:text-lg leading-relaxed max-w-4xl">
            <p>
              Aquí no hacemos "una actividad para integrar al equipo". Con las mismas herramientas artísticas del estudio más otras metodologías y recursos de campos como la innovación, la creatividad y el coaching, diseñamos experiencias para que equipos de alto desempeño se movilicen hacia la productividad y el compromiso organizacional.
            </p>
            <p>
              Creemos que la cultura en las empresas facilita llegar más rápido a los objetivos al fortalecer habilidades como liderazgo, accountability, alineación de propósitos y metas y reconocimiento, para inspirar desde lo individual y colectivo a la acción. Porque lo que transforma no es un certificado que se cuelga en la pared — son las emociones, reflexiones y aprendizajes nuevos que nos llevamos puestos en nuestra actitud, mente y corazón.
            </p>
            <p className="text-white/85 font-medium">
              Dell, Abbot, ING.
            </p>
          </div>

          <div className="mt-14 md:mt-16 pt-10 border-t border-white/10 max-w-4xl">
            <h5 className="font-display font-bold text-2xl md:text-3xl lg:text-4xl text-white leading-tight">
              Dos universos, un <span className="text-gradient-music">mismo</span> <span className="text-gradient-teams">oficio</span>.
            </h5>
            <p className="mt-5 text-white/75 text-base md:text-lg leading-relaxed">
              Hacemos que una marca se reconozca por cómo suena, y que un equipo reconozca su potencial después de vivir y construir algo juntos. En ambos casos, convertimos la emoción en experiencia estratégica para lograr objetivos.
            </p>
          </div>
        </div>
      </section>

      {/* TEAM — Tres personas. Un solo cruce. */}
      <section className="relative bg-neutral-950 py-20 md:py-28 px-6 border-y border-white/5">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.02] max-w-4xl">
            Tres personas. <span className="text-gradient-music">Un solo cruce</span>.
          </h2>

          <div className="mt-14 md:mt-20 space-y-20 md:space-y-28">
            {TEAM.map((p) => (
              <article key={p.name} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
                {/* Photo */}
                <div className="lg:col-span-4">
                  <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-black aspect-[4/5]">
                    <img src={p.photo} alt={p.name} loading="lazy" decoding="async" className="w-full h-full object-cover grayscale-[15%] hover:grayscale-0 transition-all duration-[900ms]" />
                    <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black via-black/60 to-transparent pointer-events-none" />
                    <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-black/70 backdrop-blur border border-white/15">
                      <span className="w-1.5 h-1.5 rounded-full" style={{ background: p.color }} />
                      <span className="font-mono-caps text-[10px] md:text-xs tracking-[0.18em] uppercase text-white/85">{p.role}</span>
                    </div>
                  </div>
                </div>

                {/* Bio */}
                <div className="lg:col-span-8 min-w-0">
                  <h3 className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-[0.03em] uppercase leading-tight" style={{ color: p.color }}>
                    {p.name}
                  </h3>
                  <p className="mt-3 font-display text-xl md:text-2xl leading-snug text-white/90">
                    {p.subtitle}
                  </p>
                  <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed">
                    {p.bio}
                  </p>
                  <p className="mt-4 text-white/55 text-sm md:text-base leading-relaxed">
                    {p.extra}
                  </p>
                </div>

                {/* Trayectoria — full width beneath */}
                <div className="lg:col-span-12">
                  <div className="rounded-2xl border border-white/10 overflow-hidden bg-black">
                    <img
                      src={p.trayectoria}
                      alt={`${p.name} — trayectoria`}
                      loading="lazy"
                      decoding="async"
                      className="w-full h-auto"
                    />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CLIENTES */}
      <section className="relative bg-black py-20 md:py-28 px-6">
        <div className="max-w-7xl mx-auto">
          <p className="font-mono-caps text-xs tracking-[0.3em] uppercase text-[#ff8a3c] mb-4">— Clientes —</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.02] max-w-4xl">
            Algunas marcas que nos han dejado entrar a su <span className="text-gradient-music">identidad</span> —y a sus <span className="text-gradient-teams">equipos</span>.
          </h2>
          <p className="mt-5 text-white/60 text-base md:text-lg leading-relaxed max-w-3xl">
            Ellos ya suenan y mueven sus equipos con nosotros.
          </p>

          <div className="mt-14 md:mt-20 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {CLIENT_LOGOS.map((logo, i) => (
              <div
                key={i}
                className="group relative aspect-square rounded-2xl border border-white/10 bg-black overflow-hidden hover:border-white/25 transition-colors"
              >
                <img
                  src={logo.image}
                  alt={logo.name}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-500"
                />
                <span className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-100 group-hover:opacity-0 transition-opacity" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer footer={content.footer} />
      <WhatsAppButton />
    </div>
  );
}
